import React, { useState } from 'react';
import logo from '../../images/logo.png'
import x from "../../images/x.png"
import insta from "../../images/insta.png"
import youtube from "../../images/youtube.png"
import tiktok from "../../images/tiktok.png"
import { Link } from 'react-router-dom';

const SOCIAL_LINKS = {
    x: 'https://twitter.com/LilverseGlobal',
    insta: 'https://www.instagram.com/lilverseofficial/',
    tiktok: 'https://www.tiktok.com/@lilverse_official',
    youtube: 'https://www.youtube.com/channel/UC1QNA8R88ERxQd8rslXOKaw',
};

const NAV_LINKS = [
    { to: '/animations', label: 'Animations' },
    { to: '/nft', label: 'Digital collectibles' },
    { to: '/fashion', label: 'Fashion' },
];

const Header = ({className}) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = () => {
        setIsOpen(!isOpen)
    }
    return (
        <div className={`bg_header min-h-[80px] lg:min-h-[96px] 2xl:min-h-[106px] 5xl:min-h-[136px] w-full overflow-hidden ${className}`}>
            <div className="relative containers hidden md:flex items-center h-full py-4">
                <div className="relative z-50 flex items-center justify-between w-full h-full gap-6" >
                    <Link to={'/'} className="flex gap-4 items-center min-w-0 shrink-0">
                        <img src={logo} className="w-[50px] h-[60px] lg:w-[60px] lg:h-[72px] shrink-0"  alt="logotype" />
                        <h2 className="text-[clamp(1.75rem,4.2vw,4.5rem)] text-[#FE9ECE] text-with-border leading-none whitespace-nowrap">LILVERSE</h2>
                    </Link>
                    <nav className="flex items-center gap-6 shrink-0">
                        {NAV_LINKS.map((link) => (
                            <Link
                                key={link.to}
                                to={link.to}
                                className="font-mons text-[clamp(0.8rem,1vw,1rem)] text-[#FE9ECE] hover:underline whitespace-nowrap"
                            >
                                {link.label}
                            </Link>
                        ))}
                    </nav>
                </div>
            </div>
            <div className="relative containers flex md:hidden justify-between items-center h-full min-h-[80px] py-3 gap-3">
                <img src={logo} className={isOpen ? "hidden" : "w-[42px] h-[50px] shrink-0"} alt="logotype" />
                <div className={isOpen ? "hidden" : "flex flex-col gap-0 relative min-w-0 flex-1 overflow-hidden"}>
                    <h2 className="text-[clamp(1.5rem,8.5vw,2.5rem)] text-[#FE9ECE] text-with-border leading-tight truncate">LILVERSE</h2>
                    <p className="text-[10px] xs:text-[11px] tracking-tight text-[#FE9ECE] lines capitalize truncate">
                        Animations, comics, memes and more!
                    </p>
                </div>
                <button
                    type="button"
                    onClick={handleOpen}
                    aria-label={isOpen ? 'Close menu' : 'Open menu'}
                    aria-expanded={isOpen}
                    className={isOpen? "hidden":"w-[50px] h-[50px] shrink-0 rounded-full bg-[#FE9ECE] border-[2px] border-white p-[13px] flex flex-col gap-[5px] items-center justify-center"}>
                    <span className="h-[2px] w-full bg-white"></span>
                    <span className="h-[2px] w-full bg-white"></span>
                    <span className="h-[2px] w-full bg-white"></span>
                </button>
                {isOpen ?
                    <div className="absolute top-2.5 right-0 z-50 w-full rounded-[28px] bg-[#FE9ECE] border-[2px] border-white p-[14px] flex flex-col gap-4 items-center justify-center">
                        <nav className="flex flex-col gap-2 items-center">
                            {NAV_LINKS.map((link) => (
                                <Link key={link.to} to={link.to} onClick={handleOpen} className="font-mons text-white text-sm">
                                    {link.label}
                                </Link>
                            ))}
                        </nav>
                        <div className="flex gap-6 items-center justify-center relative w-full">
                            <a href={SOCIAL_LINKS.x} target="_blank" rel="noopener noreferrer" aria-label="Lilverse on X"><img src={x} className="w-[37px] h-[37px]" alt="X" /></a>
                            <a href={SOCIAL_LINKS.insta} target="_blank" rel="noopener noreferrer" aria-label="Lilverse on Instagram"><img src={insta} className="w-[37px] h-[37px]" alt="Instagram" /></a>
                            <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="Lilverse on TikTok"><img src={tiktok} className="w-[37px] h-[37px]" alt="TikTok" /></a>
                            <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noopener noreferrer" aria-label="Lilverse on YouTube"><img src={youtube} className="w-[37px] h-[37px]" alt="YouTube" /></a>
                            <button
                                type="button"
                                onClick={handleOpen}
                                aria-label="Close menu"
                                className="absolute right-2 bg-transparent border-0 p-0"
                            >
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 16.5563L16.5563 0.999987" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                                    <path d="M1 1L16.5563 16.5563" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    :
                    null}
            </div>
        </div>
    );
};

export default Header;
